(function () {
  angular.module('binky.core.common.analytics', ['binky.core.lodash']);
})();
